'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const S7S7Tablet = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("rect", {
                width: 48,
                height: 48,
                fill: "white",
                rx: 24
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#C4D600",
                fillRule: "evenodd",
                d: "M48 24.005C48 37.265 37.262 48 24.007 48 10.751 48 0 37.264 0 24.005S10.75 0 24.007 0C37.263 0 48 10.746 48 24.005M14.174 12.436c1.765-.655 4.204-.863 7.964-.863h3.392l-1.66 4.15h-2.324c-2.496 0-4.098.007-4.963.294-.842.261-1.464.578-1.803 1.074-.313.401-.42.949-.42 1.424 0 .498.056.97.549 1.603.608.607 1.61 1.39 3.574 2.6 3.918 2.444 5.077 4.384 5.077 6.938 0 4.154-3.919 8.122-10.486 8.122-1.974 0-4.73-.289-5.891-.66l-.61-.178c.238-.791 1.018-2.97 1.361-3.891l.616.155c1.291.316 3.311.502 4.652.502 3.843 0 5.336-1.735 5.336-3.26 0-1.392-.76-2.156-4.573-4.467-3.573-2.209-4.808-4.13-4.808-6.78 0-3.184 2.05-5.607 5.017-6.763m13.85-.863h11.68c.548 0 .653.388.442.81-.764 1.893-7.97 19.947-7.97 19.947H27.36s5.691-14.503 6.636-16.663c-.219 0-.42.006-.688.014-.536.017-1.337.042-3.073.042h-3.871z",
                clipRule: "evenodd"
            })
        ]
    })));

export { S7S7Tablet, S7S7Tablet as default };
//# sourceMappingURL=S7S7Tablet.js.map
